import { render } from "./CategorySale.vue?vue&type=template&id=8e4df56e&ts=true"
import script from "./CategorySale.vue?vue&type=script&lang=ts"
export * from "./CategorySale.vue?vue&type=script&lang=ts"

import "./CategorySale.vue?vue&type=style&index=0&id=8e4df56e&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__